import createLucideIcon from '../createLucideIcon';

const UserX = createLucideIcon('UserX', [
  ['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', key: '1yyitq' }],
  ['circle', { cx: '9', cy: '7', r: '4', key: 'nufk8' }],
  ['line', { x1: '17', x2: '22', y1: '8', y2: '13', key: '3nzzx3' }],
  ['line', { x1: '22', x2: '17', y1: '8', y2: '13', key: '1swrse' }],
]);

export default UserX;
